import { render, staticRenderFns } from "./formatted-date.vue?vue&type=template&id=17850b6d"
import script from "./formatted-date.vue?vue&type=script&lang=js"
export * from "./formatted-date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports